<template>
    <div class="navbar">
        <div class="left-menu">
            <hamburger id="hamburger-container" :is-active="sidebar.opened"  class="hamburger-container" @toggleClick="toggleSideBar"  v-if="!sidebar.hide"/>
            <Breadcrumb  v-if="!sidebar.hide"/>
        </div>
        <div class="right-menu">
            <el-select
                v-model="value"
                placeholder="Select"
                size="large"
                style="width: 140px;margin-right: 10px;"
                @change="changDept"
                >
                <el-option
                    v-for="item in options"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId"
                />
            </el-select>
            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
                    <img :src="avatar" class="user-avatar">
                    <span class="user-name">{{ name }}</span>
                    <el-icon size="20"><ArrowDown /></el-icon>
                </div>
                <template #dropdown>
                    <el-dropdown-menu>
                        <router-link to="/user/profile">
                            <el-dropdown-item>个人中心</el-dropdown-item>
                        </router-link>
                        <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu> 
                </template>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import TopNav from '@/components/TopNav';
    import Breadcrumb from '@/components/Breadcrumb';
    import Hamburger from '@/components/Hamburger';
    import { mapGetters, mapState } from 'vuex';
    import { getDeptById, setDeptId, getCurrentDept } from '@/api/system/depart';
    export default {
        components: { TopNav, Breadcrumb, Hamburger },
        data() {
            return {
                options: [],
                value: '',
            }
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch('app/toggleSideBar')
            },
            logout() {
                this.$confirm('确定注销并退出系统吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('LogOut').then(() => {
                        location.href = '/index';
                    })
                }).catch(() => {});
            },
            changDept() {
                setDeptId(this.value).then(res => {
                    this.$modal.msgSuccess('切换科室成功')
                    location.reload();
                })
            }
        },
        mounted() {
            getDeptById(this.userName).then(res => {
                this.options = res.data;
                getCurrentDept().then(res => {
                    this.value = res.data.deptId
                })
            })
        },
        computed: {
            ...mapGetters(['scope', 'sidebar', 'name', 'avatar', 'deptId', 'userName']),
            ...mapState({
                sidebar: state => state.app.sidebar,
            }),
        },
    }
</script>

<style lang="scss" scoped>
    .navbar{
        display: flex;
        justify-content: space-between;
        height: 60px;
        align-items: center;
        .left-menu{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .right-menu{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .avatar-wrapper{
                display: flex;
                align-items: center;
                .user-name{
                    margin: 0 10px;
                }
                .user-avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }
            }
        }
    }
</style>